var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isLogin
    ? _c(
        "b-dropdown",
        {
          ref: "header-alert",
          staticClass: "alert-header",
          attrs: {
            size: "sm",
            variant: "link",
            "toggle-class": "icn-route-btn alert-btn",
            "menu-class": "header-menu",
            "no-caret": "",
            right: "",
            text: "Right align",
            lazy: "",
          },
          scopedSlots: _vm._u(
            [
              {
                key: "button-content",
                fn: function () {
                  return [
                    _c("div", { staticClass: "alert_img" }, [
                      _c("img", {
                        attrs: {
                          src: `${_vm.$s3}/img/common/Header/alert.svg?${_vm.$ver}`,
                        },
                      }),
                      _vm.newNoti
                        ? _c("span", { staticClass: "img_badge" })
                        : _vm._e(),
                    ]),
                  ]
                },
                proxy: true,
              },
            ],
            null,
            false,
            1918619583
          ),
        },
        [
          _c(
            "AlertContent",
            _vm._b({}, "AlertContent", { goToAlert: _vm.goToAlert }, false)
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }